import { Dispatch, SetStateAction } from 'react';
import { NetworkType, RpcDetailType } from '../../../types/network';
import LandingCard from './LandingCard';
import LandingStakingCard from './LandingStakingCard';

interface Props {
    networkData: NetworkType[];
    setRpcDetail: (x: RpcDetailType) => void;
    setFlag: (x: boolean) => void;
    networkPayment: boolean;
    setNodeId: (x: string) => void;
    nodeID: string;
    setCodes: Dispatch<SetStateAction<any>>;
    networkType: 'dedicated' | 'staking';
    syncBlockHeight: () => void;
    managedHosting:boolean;
}
const NodeCard = ({
    networkData,
    setRpcDetail,
    setFlag,
    networkPayment,
    setNodeId,
    nodeID,
    setCodes,
    networkType,
    syncBlockHeight,
    managedHosting,
}: Props) => (
    <>
                
        {networkType === 'dedicated' && (
            <>
                
                <div>
                    {networkData.length === 0 && (
                        <div
                            style={{
                                color: '#ABB2B9',
                                textAlign: 'center',
                                fontSize: '20px',
                                marginTop: '5%',
                            }}
                        >
                            No Node Data
                        </div>
                    )}
                    <section className='mx-2 mb-2 '>
                        {networkType === 'dedicated' &&
                            networkData &&
                            networkData.length > 0 &&
                            networkData.map((data, idx) => (
                                <LandingCard
                                    key={`node-card${idx.toString()}`}
                                    state={data.status}
                                    nodeName={data.node_name}
                                    endpoint={data.endpoint}
                                    cloudimage={data.cloud_id.toString()}
                                    region={data.region_id.toString()}
                                    networkId={data.network_id}
                                    node={data.node_id}
                                    redirection_url={data.redirection_url}
                                    setRpcDetail={setRpcDetail}
                                    setFlag={setFlag}
                                    networkPayment={networkPayment}
                                    setNodeId={setNodeId}
                                    nodeID={nodeID}
                                    setCodes={setCodes}
                                    managedHosting={managedHosting}
                                />
                            ))}
                    </section>
                </div>
            </>
        )}
        {networkType === 'staking' &&
            networkData &&
            networkData.length > 0 &&
            networkData.map((data, idx) => (
                <LandingStakingCard
                    key={`node-card${idx.toString()}`}
                    state={data.status}
                    nodeName={data.node_name}
                    endpoint={data.endpoint}
                    cloudimage={data.cloud_id.toString()}
                    region={data.region_id.toString()}
                    networkId={data.network_id}
                    node={data.node_id}
                    redirection_url={data.redirection_url}
                    setRpcDetail={setRpcDetail}
                    setFlag={setFlag}
                    networkPayment={networkPayment}
                    setNodeId={setNodeId}
                    nodeID={nodeID}
                    setCodes={setCodes}
                    createdAt={data.created_at}
                    networkType={data.inputs.network}
                    syncBlockHeight={syncBlockHeight}
                    managedHosting={managedHosting}
                />
            ))}
    </>
);
export default NodeCard;
